<div *ngIf="visualItemInfo" class="visual-item-info">
  <a (click)="visualItemInfo.action()">
    <div class="art-box">
      <div>
        <app-h2-adapting-size [text]="visualItemInfo.title"></app-h2-adapting-size>
      </div>
    </div>
  </a>
</div>
